import Snackbar from 'node-snackbar';
import MicroModal from "./micromodal";

export default class WpcfSnackbar {
  static selectorString() {
    return '.js-wpcf-snackbar';
  }

  constructor(rootNode) {
    const wpcf7 = rootNode.querySelector('.wpcf7');

    if (wpcf7) {
      wpcf7.addEventListener('wpcf7mailsent', () => {
        Snackbar.show({
          pos: 'bottom-right',
          text: 'Anfrage wurde übermittelt.',
          actionText: 'OK',
        });
      });

      wpcf7.addEventListener('wpcf7invalid', () => {
        Snackbar.show({
          pos: 'bottom-right',
          text: 'Fehler: Überprüft eure Angaben.',
          actionText: 'OK',
        });
      });
    }
  }
}
